import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Edit2, Phone, Mail, MapPin, FileText } from 'lucide-react';
import { CompanyProfile } from '@/lib/company-store';

interface CompanyProfileCardProps {
  company: CompanyProfile;
  onEdit: () => void;
}

export const CompanyProfileCard = ({ company, onEdit }: CompanyProfileCardProps) => {
  return (
    <Card>
      <CardContent className="pt-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Logo Section */}
          <div className="flex flex-col items-center">
            {company.logo ? (
              <div className="w-32 h-32 border-2 border-slate-300 rounded-lg flex items-center justify-center overflow-hidden bg-slate-50 mb-4">
                <img src={company.logo} alt="Logo Syarikat" className="w-full h-full object-contain p-2" />
              </div>
            ) : (
              <div className="w-32 h-32 border-2 border-dashed border-slate-300 rounded-lg flex items-center justify-center bg-slate-50 mb-4 text-slate-400">
                Logo
              </div>
            )}
            <Button size="sm" variant="outline" onClick={onEdit} className="gap-2">
              <Edit2 size={16} />
              Sunting
            </Button>
          </div>

          {/* Company Info */}
          <div className="md:col-span-2 space-y-4">
            <div>
              <h3 className="text-2xl font-bold text-slate-900">{company.nama}</h3>
              <p className="text-sm text-slate-600 mt-1">Pemilik: {company.namaOwner}</p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="flex items-start gap-3">
                <FileText className="text-red-600 mt-1 flex-shrink-0" size={20} />
                <div>
                  <p className="text-xs text-slate-600">No. Pendaftaran</p>
                  <p className="text-sm font-medium text-slate-900">{company.noPendaftaran}</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <Phone className="text-red-600 mt-1 flex-shrink-0" size={20} />
                <div>
                  <p className="text-xs text-slate-600">Telefon</p>
                  <p className="text-sm font-medium text-slate-900">{company.noTel}</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <Mail className="text-red-600 mt-1 flex-shrink-0" size={20} />
                <div>
                  <p className="text-xs text-slate-600">Emel</p>
                  <p className="text-sm font-medium text-slate-900">{company.email}</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <MapPin className="text-red-600 mt-1 flex-shrink-0" size={20} />
                <div>
                  <p className="text-xs text-slate-600">Alamat</p>
                  <p className="text-sm font-medium text-slate-900">{company.alamat}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};